export const FLEX_GENERAL_ERROR_CODE = '10000';
export const ENDPOINT_UNAVAILABLE_ERROR_CODE = '210';

// Only one active username is allowed per master contact
export const SF_ACCOUNT_EXISTS_ERROR_CODE = '250';